export function getMetaTagContentByName(name: string, defaultValue = '') {
  return document.querySelector(`meta[name="${name}"]`)?.getAttribute('content') ?? defaultValue;
}
